import { render, staticRenderFns } from "./levelList.vue?vue&type=template&id=001f8c90&scoped=true&"
import script from "./levelList.vue?vue&type=script&lang=js&"
export * from "./levelList.vue?vue&type=script&lang=js&"
import style0 from "./levelList.vue?vue&type=style&index=0&id=001f8c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f8c90",
  null
  
)

export default component.exports